import React from "react";
import { Icons } from "../../atoms/Icons";
import Buttons from "../../atoms/Buttons";
import "./futurecalc-modal.scss";

const FutureCalcTaxfreeModal = (props) => {
  return (
    <div className="heads-up-modal">
      <div className="text-end">
        <Icons
          iconname="close-large"
          variant="icon-sixteen-px"
          clickHandler={props.handleCloseButton}
        />
      </div>
      <div className="heading mt-2 mb-4">Tax-free/Taxable cash</div>
      <div className="sub-text">
        <p>
          You can usually take up to 25% of your pension as a tax-free cash lump
          sum. Any portion over 25% will be subject to income tax when you take
          it.{" "}
        </p>
        <p>
          Taking a taxable portion will limit the maximum amount that you can
          pay into a pension in the future. This is called the Money Purchase
          Annual Allowance.
        </p>
      </div>
      <div className="text-end mt-5">
        <Buttons
          className={`primary`}
          name={"Got it!"}
          handleClick={props.handleClick}
        />
      </div>
    </div>
  );
};

export default FutureCalcTaxfreeModal;
